document.addEventListener('DOMContentLoaded', function() {
    const categoryButtons = document.querySelectorAll('.category-btn');
    const searchInput = document.getElementById('live-search');
    const postsContainer = document.querySelector('.posts-content');

    let activeCategory = '';
    let debounceTimeout = null;

    // Comprobar que los elementos existen
    if (!categoryButtons.length || !searchInput || !postsContainer) {
        return;
    }

    function fetchNews() {
        toggleProgressBar();
        const searchTerm = searchInput.value.trim();
        let params = new URLSearchParams();
        if (activeCategory) params.append('category', activeCategory);
        if (searchTerm) params.append('search', searchTerm);

        // Añadir el $postType si existe
        params.append('post_type', postType ?? 'noticia');

        // Opcional: loading visual
        if (postsContainer) {
            postsContainer.innerHTML = '<div class="loading"><span>Cargando...</span></div>'
        }

        fetch(`/wp-admin/admin-ajax.php?action=filter_news&${params.toString()}`)
            .then(response => response.text())
            .then(html => {
                // Reemplaza el contenido de noticias
                const oldPosts = document.querySelector('.posts-content') || document.querySelector('.no-results')?.parentNode;
                if (oldPosts) oldPosts.outerHTML = html;
            }).finally(obj => {
            toggleProgressBar();
        })
    }

    // Botones de categorías
    categoryButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            categoryButtons.forEach(b => {
                b.classList.remove('active');
                b.classList.add('transparent');
            });
            this.classList.add('active');
            this.classList.remove('transparent');
            activeCategory = this.dataset.category;
            fetchNews();
        });
    });

    // Búsqueda con debounce
    searchInput.addEventListener('input', function() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(fetchNews, 300);
    });

    // Opcional: cargar desde URL si hay parámetros
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('category')) {
        activeCategory = urlParams.get('category');
        categoryButtons.forEach(btn => {
            if (btn.dataset.category === activeCategory) btn.classList.add('active');
            else btn.classList.remove('active');
        });
    }
    if (urlParams.has('s')) searchInput.value = urlParams.get('s');

    // Inicial
    // fetchNews(); // Descomenta si quieres que cargue al entrar
});